<template>
    <div class="modal fade" id="importGatewaysModal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalLabel">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t("common_importFromXLSFile") }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="kt-section kt-section--first">
                        <h3 class="kt-section__title">{{ $t("common_importStepOneText") }}</h3>
                        <div role="alert" class="alert alert-secondary">
                            <div class="alert-icon">
                                <i class="flaticon-info kt-font-brand"></i>
                            </div>
                            <div class="alert-text">{{ $t("gtw_importGatewaysHelpText") }}</div>
                        </div>
                        <div class="kt-section__body kt-align-center">
                            <a download :href="templateImportGateways" class="btn btn-success btn-sm btn-bold kt-margin-l-10" id="importGateways_downloadExcelTemplate">
                                <i class="fa fa-file-excel kt-margin-r-5"></i>
                                {{ $t("common_downloadXlsTemplate") }}
                            </a>
                        </div>

                        <div class="kt-separator kt-separator--border-dashed kt-separator--space-lg"></div>

                        <h3 class="kt-section__title">{{ $t("common_importStepTwoText") }}</h3>

                        <div class="kt-section__body">
                            <div class="form-group kt-margin-b-0">
                                <label>{{ $t("common_fileBrowser") }}</label>
                                <div class="custom-file">
                                    <input type="file" @change="handleFileSelected" ref="xlsFile" :lang="this.$i18n.locale" class="custom-file-input cursorPointer" accept=".xlsx" id="importGatewaysInputFile" />
                                    <label class="custom-file-label" id="importGatewaysInputLabel" for="customFile">{{ $t("common_chooseFile") }}</label>
                                    <span class="form-text text-muted">{{ $t("gtw_pleaseSelectXLSFile") }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="isXlsFileIsEmpty" class="kt-font-danger marginTMinus15">{{ $t("common_fileIsEmpty") }}</div>
                    <div v-if="isSheetNotFound" class="kt-font-danger marginTMinus15">{{ $t("gtw_gatewaysSheetNotFound") }}</div>

                    <div v-show="errorDisplayed" class="kt-section kt-margin-t-15 kt-margin-b-0">
                        <div class="kt-font-danger kt-margin-t-15 kt-margin-b-15">{{ $t("common_invalidXlsFile") }}</div>
                        <div class="kt-scroll" data-scroll="true" data-height="160">
                            <div class="kt-section__content">
                                <table class="table kt-font-danger table-sm">
                                    <thead>
                                        <tr>
                                            <th class="kt-align-center">{{ $t("common_rowNumber") }}</th>
                                            <th class="kt-align-center">{{ $t("error_message") }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(errorObj, i) in this.xlsErrors" :key="i">
                                            <td v-if="errorObj.row" class="kt-align-center font12" scope="row">{{ errorObj.row + 1 }}</td>
                                            <td v-else class="kt-align-center font12" scope="row">{{ $t("common_many") }}</td>

                                            <td v-if="errorObj.error == 'required'" class="kt-align-center font12">{{ $t("common_fieldIsRequired", { value: errorObj.column }) }}</td>
                                            <td v-else class="kt-align-center font12">{{ $t(errorObj.error, { value: errorObj.value }) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button id="importGatewaysModalImportButton" type="button" @click="importGateways" v-bind:disabled="isImportButtonDisabled || localIsUploadGatewaysInProgress" :class="{ 'btn btn-brand kt-margin-r-5 kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': localIsUploadGatewaysInProgress, 'btn btn-brand kt-margin-r-5': !localIsUploadGatewaysInProgress }">
                        {{ $t("common_import") }}
                    </button>
                    <button id="importGatewaysModalCancelButton" type="button" class="btn btn-secondary" data-dismiss="modal">
                        {{ $t("common_cancel") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import readXlsxFile from "read-excel-file";
const regexUtil = require("../../constants/regex");
const gatewayModels = require("../../constants/gateways");
const arubaGatewayModels = require("../../constants/arubaGateways");

export default {
    data() {
        return {
            errorDisplayed: false,
            xlsData: null,
            isImportButtonDisabled: true,
            xlsErrors: null,
            xlsFile: null,
            isXlsFileIsEmpty: false,
            isSheetNotFound: false,
            localIsUploadGatewaysInProgress: false,
            templateImportGateways: "/assets/xls-templates/template_import_gateways.xlsx",
            gatewayModelsList: []
        };
    },
    created: function() {
        console.log("Component(ImportGatewaysModal)::created() - called");
        this.gatewayModelsList = [...gatewayModels.list];
    },
    mounted: function() {
        console.log("Component(ImportGatewaysModal)::mounted() - called");
    },
    destroyed: function() {
        console.log("Component(ImportGatewaysModal)::destroyed() - called");
        this.gatewayModelsList = [];
    },
    validations: {
        // -- validations -- List of controls to apply to validate a form.
        // --
    },
    watch: {
        // -- Watch -- Property to perform asynchronous or expensive operations in response to changing component "data".
        // --
        isUploadGatewaysInProgress: function() {
            this.localIsUploadGatewaysInProgress = this.isUploadGatewaysInProgress;
        },
        showImportGatewaysModal() {
            if (this.showImportGatewaysModal) {
                console.log("Component(ImportGatewaysModal)::showImportGatewaysModal() - show modal");
                $("#importGatewaysModal").modal("show");
            }
            this.resetShowImportGatewaysModal();
        },
        hideImportGatewaysModal() {
            if (this.hideImportGatewaysModal) {
                console.log("Component(ImportGatewaysModal)::hideImportGatewaysModal() - hide modal");
                $("#importGatewaysModal").modal("hide");
            }
            this.resetHideImportGatewaysModal();
        },
        currentSite(site) {
            console.log("Component(ImportGatewaysModal)::watch(currentSite) called with : ", site);
            if (site && site.BLEGatewaysType === "OMNIACCESS_OEM") {
                this.templateImportGateways = "/assets/xls-templates/template_import_OEM_gateways.xlsx";
                this.gatewayModelsList = _.uniq(gatewayModels.list.concat(arubaGatewayModels.list));
            }
        }
    },
    computed: {
        // -- Computed -- Property will only re-evaluate when some of its reactive dependencies have changed.
        // To compose new data from existing datasource
        // To reference a value from the template (cached value)
        // --
        ...mapGetters(["showImportGatewaysModal", "hideImportGatewaysModal", "isUploadGatewaysInProgress", "currentSite"])
    },
    methods: {
        ...mapActions(["massImportGateways", "resetShowImportGatewaysModal", "resetHideImportGatewaysModal"]),
        // -- Methods -- Property to perform an action.
        // To react on some event happening in the DOM (called every time an event occurs even if method returns the same result)
        // To call a function when something happens in your component (from property "computed" or "watch")
        // ---
        handleFileSelected() {
            console.log("Component(ImportGatewaysModal)::handleFileSelected() - called");
            let self = this;
            this.errorDisplayed = false;
            this.isXlsFileIsEmpty = false;
            this.isSheetNotFound = false;

            if (this.$refs.xlsFile.files.length > 0) {
                this.xlsFile = this.$refs.xlsFile.files[0];

                const schema = {
                    Name: {
                        prop: "name",
                        type: String,
                        required: true,
                        parse(value) {
                            let valueName = value.toString();
                            if (valueName.length < 2) {
                                throw new Error("error_wrongNameLength");
                            }
                            return valueName;
                        }
                    },
                    "BLE Mac Address": {
                        prop: "bleMacAddress",
                        type: String,
                        required: true,
                        parse(value) {
                            if (!regexUtil.macAddress.test(value)) {
                                throw new Error("error_badMacAddressFormat");
                            }
                            return value.toUpperCase();
                        }
                    },
                    "Wifi Mac Address": {
                        prop: "wifiMacAddress",
                        type: String,
                        parse(value) {
                            if (!regexUtil.macAddress.test(value)) {
                                throw new Error("error_badMacAddressFormat");
                            }
                            return value.toUpperCase();
                        }
                    },
                    "IP Address": {
                        prop: "ipAddress",
                        type: String,
                        parse(value) {
                            if (!regexUtil.ipAddress.test(value)) {
                                throw new Error("error_ipAddressFormat");
                            }
                            return value;
                        }
                    },
                    Model: {
                        prop: "model",
                        type: String,
                        parse(value) {
                            if (!self.gatewayModelsList.includes(value)) {
                                if (self.currentSite.BLEGatewaysType === "OMNIACCESS_OEM") {
                                    throw new Error("error_wrongArubaGatewayModelNameValue");
                                } else {
                                    throw new Error("error_wrongGatewayModelNameValue");
                                }
                            }
                            return value;
                        }
                    },
                    "Software Version": {
                        prop: "softwareVersion",
                        type: String
                    },
                    "Group Name": {
                        prop: "groupName",
                        type: String
                    },
                    "Floor Elevation": {
                        prop: "floorElevation",
                        type: Number
                    },
                    "Keywords ( ; as separator )": {
                        prop: "keywords",
                        type: String
                    }
                };

                readXlsxFile(this.xlsFile, { schema, sheet: "gateways" })
                    .then(({ rows, errors }) => {
                        if (rows.length == 0 && errors.length == 0) {
                            this.isXlsFileIsEmpty = true;
                            return;
                        }

                        const arrayOfBleMacAddresses = _.map(rows, "bleMacAddress");
                        const arrayOfWifiMacAddresses = _.map(rows, "wifiMacAddress");
                        var allGateways = _.compact(arrayOfBleMacAddresses.concat(arrayOfWifiMacAddresses));
                        var occurrences = allGateways.reduce(function(obj, item) {
                            obj[item] = (obj[item] || 0) + 1;
                            return obj;
                        }, {});
                        // Check manually for mac addresses unicity in entore file
                        for (let macAddr in occurrences) {
                            if (occurrences[macAddr] > 1) {
                                // Push an error
                                errors.push({
                                    error: "error_macAddressesMustHaveDifferentsValues",
                                    value: macAddr
                                });
                            }
                        }
                        if (errors.length > 0) {
                            this.errorDisplayed = true;
                            this.isImportButtonDisabled = true;
                            this.xlsErrors = errors;
                        } else {
                            this.errorDisplayed = false;
                            this.isImportButtonDisabled = false;
                            this.xlsData = rows;
                        }
                    })
                    .catch(err => {
                        if (err.message.indexOf('Sheet "gateways" not found') != -1) {
                            this.isSheetNotFound = true;
                            this.isImportButtonDisabled = true;
                        }
                    });
            }
        },
        importGateways() {
            console.log("Component(ImportGatewaysModal)::importGateways() - called");

            let gateways = [];
            for (var currentLine of this.xlsData) {

                let obj = {};
                if (currentLine.hasOwnProperty("name")) {
                    obj.name = currentLine.name;
                }
                if (currentLine.hasOwnProperty("bleMacAddress")) {
                    obj.bleMacAddress = currentLine.bleMacAddress;
                }
                if (currentLine.hasOwnProperty("wifiMacAddress")) {
                    obj.wifiMacAddress = currentLine.wifiMacAddress;
                }
                if (currentLine.hasOwnProperty("model")) {
                    obj.model = currentLine.model;
                }
                if (currentLine.hasOwnProperty("softwareVersion")) {
                    obj.softwareVersion = currentLine.softwareVersion;
                }
                if (currentLine.hasOwnProperty("groupName")) {
                    obj.groupName = currentLine.groupName;
                }
                if (currentLine.hasOwnProperty("ipAddress")) {
                    obj.ipAddress = currentLine.ipAddress;
                }
                if (currentLine.hasOwnProperty("floorElevation")) {
                    obj.floorElevation = currentLine.floorElevation;
                }
                if (currentLine.hasOwnProperty("keywords")) {
                    obj.keywords = currentLine.keywords;
                }
                gateways.push(obj);
            }
            let data = { siteId: this.$route.params.siteId, gateways: gateways };
            // Create the new site in the backend
            this.massImportGateways(data);
        }
    },
    components: {
        // -- Components -- List of local components used in the current template
        // --
    }
};
</script>

<style scoped>
.cursorPointer {
    cursor: pointer;
}
.marginTMinus15 {
    margin-top: -15px;
}
</style>
<style>
.font12 {
    font-size: 12px;
}
</style>
